export default __webpack_public_path__ + "static/media/Info.303bd387.svg";